import Call from '../../Call.v2';

const Countries = {
    get() {
        return Call(`filler/countries`);
    },

    save(countries) {
        return Call(`filler/countries`, 'POST', { countries });
    },
};

export default Countries;


// WEBPACK FOOTER //
// ./src/services/API/components/Filler/Countries.js